export const setMetaDescription = (title:string):void => {
  let meta = document.getElementById("MetaDescription")
  meta?.setAttribute('content', `${title}\ndocumentation.sas.com`)
}